var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntraInstitutionalcommunication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101 101",
    style: {
      enableBackground: "new 0 0 101 101"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0E98B4;stroke:#0E98B4;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,34.8V22.4l1.8,1.8l1.1-1.1l-3.1-3c-0.3-0.3-0.8-0.3-1.1,0l-3.1,3.1l1.1,1.1l1.8-1.8v12.4L51.2,34.8 L51.2,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.8,66.3v12.4L48,76.9L46.9,78l3.1,3c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2l3.1-3.1l-1.1-1l-1.8,1.8 V66.3H49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.4,34.5l-4.2-1.1l-0.4,1.5l2.5,0.6l-10.6,6.3l0.8,1.3l10.6-6.3l-0.6,2.5l1.5,0.4l1.1-4.2 c0.1-0.2,0-0.4-0.1-0.6C76.8,34.7,76.6,34.6,76.4,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.6,57.9L26,64.2l0.6-2.5l-1.5-0.4L24,65.5c-0.1,0.4,0.1,0.8,0.5,0.9l4.2,1.1l0.4-1.5l-2.5-0.6l10.6-6.3 L36.6,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,34.9l-0.4-1.5l-4.2,1.1c-0.4,0.1-0.6,0.5-0.5,0.9l1.1,4.2l1.5-0.4l-0.6-2.5L36.7,43l0.8-1.3l-10.6-6.3 L29.2,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.9,61.4l-1.5,0.4l0.6,2.5L64.4,58l-0.8,1.3l10.6,6.3l-2.5,0.6l0.4,1.5l4.2-1.1c0.2,0,0.4-0.2,0.5-0.3 s0.1-0.4,0.1-0.6L75.9,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,37.9c-7.1,0-12.8,5.8-12.8,12.8c0,7.1,5.8,12.8,12.8,12.8s12.8-5.8,12.8-12.8S57.6,37.9,50.5,37.9z  M50.5,62.1c-6.2,0-11.3-5.1-11.3-11.3s5.1-11.3,11.3-11.3s11.3,5.1,11.3,11.3S56.7,62.1,50.5,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,63.5c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3s6.3-2.8,6.3-6.3S20.8,63.5,17.3,63.5z M17.3,74.6 c-2.6,0-4.8-2.1-4.8-4.8s2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8S19.9,74.6,17.3,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.7,36.7c3.5,0,6.3-2.8,6.3-6.3s-2.8-6.3-6.3-6.3s-6.3,2.8-6.3,6.3S80.2,36.7,83.7,36.7z M83.7,25.6 c2.6,0,4.8,2.1,4.8,4.8s-2.1,4.8-4.8,4.8s-4.8-2.1-4.8-4.8C78.9,27.8,81.1,25.6,83.7,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,17.3c3.5,0,6.3-2.8,6.3-6.3S54,4.8,50.5,4.8s-6.3,2.8-6.3,6.3C44.2,14.5,47,17.3,50.5,17.3z M50.5,6.3 c2.6,0,4.8,2.1,4.8,4.8s-2.1,4.8-4.8,4.8s-4.8-2.1-4.8-4.8S47.9,6.3,50.5,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,83.7c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3s6.3-2.8,6.3-6.3S54,83.7,50.5,83.7z M50.5,94.8 c-2.6,0-4.8-2.1-4.8-4.8s2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8C55.3,92.6,53.1,94.8,50.5,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.7,63.5c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3s6.3-2.8,6.3-6.3S87.2,63.5,83.7,63.5z M83.7,74.6 c-2.6,0-4.8-2.1-4.8-4.8S81,65,83.7,65c2.6,0,4.8,2.1,4.8,4.8S86.3,74.6,83.7,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,24.1c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3s6.3-2.8,6.3-6.3C23.6,27,20.8,24.1,17.3,24.1z M17.3,35.2 c-2.6,0-4.8-2.1-4.8-4.8s2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8S19.9,35.2,17.3,35.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntraInstitutionalcommunication);
export default __webpack_public_path__ + "static/media/IntraInstitutionalcommunication.f91cad205e85c76ac1c665b6ef687bc3.svg";
export { ForwardRef as ReactComponent };